export default "__VITE_ASSET__BZ5zRQQW__"